import { Suspense } from "react";
import { Switch, Route, Redirect } from "react-router-dom";

import { AdminRoutes } from "./AdminRoutes";
import { WorkplaceRoutes } from "./WorkplaceRoutes";
import { WorkerRoutes } from "./WorkerRoutes";

export interface AllRoutesProps {
  isAdmin: boolean;
  isWorker: boolean;
  isWorkplace: boolean;
  renderStartPage: () => JSX.Element | null;
}

export function AllRoutes(props: AllRoutesProps) {
  const { isAdmin, isWorker, isWorkplace, renderStartPage } = props;

  const hasSession = isAdmin || isWorker || isWorkplace;

  // If user has no session (logged out), redirect to login page
  // This prevents users from getting stuck on protected routes after logout
  if (!hasSession) {
    return <Redirect to="/login" />;
  }

  return (
    <Suspense fallback={<></>}>
      <Switch>
        <Route exact path="/" render={renderStartPage} />

        <Route exact path="/enter" render={renderStartPage} />

        {isWorkplace && <WorkplaceRoutes />}

        {isWorker && <WorkerRoutes />}

        {isAdmin && <AdminRoutes />}

        {/* Catch-all route: redirect unrecognized routes to the default view */}
        <Route render={renderStartPage} />
      </Switch>
    </Suspense>
  );
}
